<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>物料管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col>
          <el-button size="mini" type="primary" icon="el-icon-plus" plain @click="addDialogVisible = true"
            >新增</el-button
          >
          <el-button
            icon="el-icon-download"
            plain
            @click="getpdfyes"
            class="download"
            type="warning"
            size="mini"
          >导出</el-button>
        </el-col>
      </el-row>
      <div>
        <el-table id="pdfDom" :data="materialist">
          <el-table-column type="index" label="序号" align="center"></el-table-column>
          <el-table-column
            label="物料编号"
            prop="MaterialCode"
            width="120px"
             align="center"
          ></el-table-column>
          <el-table-column
            label="物料名称"
            prop="MaterialName"
             align="center"
          ></el-table-column>
          <el-table-column
            label="规格型号"
            prop="Spec"
            width="120px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="CreateTimeConvert"
            width="190px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.CreateTimeConvert }}
            </template>
          </el-table-column>
          <el-table-column
            label="单位"
            prop="Unit"
            width="120px"
            align="center"
          ></el-table-column>
          <el-table-column
            label="是否使用"
            prop="Is_Use"
            width="120px"
            align="center"
          ></el-table-column>
          <el-table-column label="备注" prop="Remark" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                size="mini"
                @click="showEditDialog(scope)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                size="mini"
                @click="removeMateria(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: right;"
      >
      </el-pagination>
    </el-card>

    <!-- 添加物料的对话框 -->
    <el-dialog
      title="添加物料类型"
      :visible.sync="addDialogVisible"
      width="25%"
      @close="addDialogClosed"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="addForm"
        :rules="addFormRules"
        ref="addFormRef"
        label-width="90px"
      >
        <el-form-item label="物料名称" prop="MaterialName">
          <el-input
            v-model="addForm.MaterialName"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="物料编号" prop="MaterialCode">
          <el-input v-model="addForm.MaterialCode" style="width: 90%" size="medium"></el-input>
        </el-form-item> -->
        <el-form-item label="规格型号" prop="Spec">
          <el-input
            v-model="addForm.Spec"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="Unit">
          <el-input
            v-model="addForm.Unit"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
        <el-form-item label="场次" prop="SessionNumber" required>
          <el-input
            v-model="addForm.SessionNumber"
            style="width: 90%"
            size="medium"
            placeholder="示例:01"
          ></el-input>
        </el-form-item>
        <el-form-item label="产品类型" prop="TypeName">
          <el-select
            v-model="addForm.TypeName"
            placeholder="请选择"
            @change="selectNum($event)"
          >
            <el-option
              v-for="item in productTypelist"
              :key="item.ID"
              :label="item.TypeName"
              :value="{ code: item.TypeNo, IDS: item.ID }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否使用" prop="Is_Use">
          <el-select v-model="addForm.Is_Use" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model="addForm.Remark"
            style="width: 90%"
            size="medium"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMateria">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑物料信息的会话框 -->
    <el-dialog
      title="修改物料类型信息"
      :visible.sync="editDialogVisible"
      width="30%"
      @close="editDialogClose"
    >
      <el-form
        :model="editForm"
        :rules="editFormRules"
        ref="editFormRef"
        label-width="100px"
      >
        <el-form-item label="物料名称" prop="MaterialName">
          <el-input v-model="editForm.MaterialName"></el-input>
        </el-form-item>
        <el-form-item label="物料编号" prop="MaterialCode">
          <el-input v-model="editForm.MaterialCode"></el-input>
        </el-form-item>
        <el-form-item label="规格型号" prop="Spec">
          <el-input v-model="editForm.Spec"></el-input>
        </el-form-item>
        <el-form-item label="单位" prop="Unit">
          <el-input v-model="editForm.Unit"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editMateria">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getTypeList: {
        page: 1,
        limit: 5,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      getTypeList1: {
        page: 1,
        limit: 100,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
      },
      // 物料列表
      materialist: [],
      // 总数据条数
      total: 0,
      // 控制添加对话框的开启与关闭
      addDialogVisible: false,
      // 添加物料的表单数据
      addForm: {
        MaterialName: "",
        MaterialCode: "",
        Spec: "",
        CreateTime: "",
        Unit: "",
        Is_Use: "",
        Remark: "",
        SessionNumber: "",
        Workpiece_One: "",
        Workpiece_Two: "",
        Workpiece_Three: "",
        StorageLocationNO: "",
        StorageLocationNOP: "",
        PartStatus: "待装配",
        PartStatusNO: "01",
        WorkpieceInfo: "",
        a: 0,
        TypeName: "",
        TypeID: "",
      },
      //添加表单的验证规则对象
      addFormRules: {
        MaterialName: [
          { required: true, message: "请输入物料名称", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "物料名称的长度在2~10个字符之间",
            trigger: "blur",
          },
        ],
        MaterialCode: [
          { required: true, message: "请输入物料编码", trigger: "blur" },
          {
            min: 2,
            max: 15,
            message: "物料编码的长度在2~15个字符之间",
            trigger: "blur",
          },
        ],
        CreateTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        Unit: [
          { required: true, message: "请输入单位", trigger: "blur" },
          {
            min: 1,
            max: 15,
            message: "单位的长度在2~15个字符之间",
            trigger: "blur",
          },
        ],
        Is_Use: [
          { required: true, message: "请输入是否启用", trigger: "blur" },
          {
            min: 1,
            max: 3,
            message: "用户名的长度在1~3个字符之间",
            trigger: "blur",
          },
        ],
      },
      // 控制修改对话框的开启与关闭
      editDialogVisible: false,
      // 编辑信息的表单
      editForm: {},
      // 修改表单的验证规则对象
      editFormRules: {
        MaterialName: [
          { required: true, message: "请输入物料名称", trigger: "blur" },
        ],
        MaterialCode: [
          { required: true, message: "请输入物料编号", trigger: "blur" },
        ],
        Spec: [{ required: true, message: "请输入规格型号", trigger: "blur" }],
        Unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
      },
      // 是否启用
      options: [
        {
          value: "Y",
          label: "是",
        },
        {
          value: "N",
          label: "否",
        },
      ],
      // 工件信息
      options02: [
        {
          value: "00",
          label: "无",
        },
        {
          value: "01",
          label: "黑色",
        },
        {
          value: "02",
          label: "红色",
        },
      ],
      // 仓位信息表
      productSetingList: [],
      Workpiece_OneNum: "",
      Workpiece_TwoNum: "",
      Workpiece_ThreeNum: "",
      // 产品类型信息表
      productTypelist: [],
    };
  },
  created() {
    this.getMateriaList();
    this.getMateriaList1();
    this.getStorageInSelect();
    this.getProductType();
  },
  methods: {
    // 调用接口获取物料信息
    async getMateriaList() {
      const { data: res } = await this.$http.get("/WMS/queryMaterialset", {
        params: this.getTypeList,
      });
      console.log(res.data);
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].Is_Use == "Y") {
          res.data[i].Is_Use = "是";
        }
        if (res.data[i].Is_Use == "N") {
          res.data[i].Is_Use = "否";
        }
      }
      this.materialist = res.data;
    },
    // 调用接口获取物料信息
    async getMateriaList1() {
      const { data: res } = await this.$http.get("/WMS/queryMaterialset", {
        params: this.getTypeList1,
      });
      console.log(res.data);
      this.total = res.data.length;
    },
    // 调用接口删除物料信息
    async removeMateria(scope) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该物料, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }

      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.post(
        "/WMS/deleteMaterialset",
        params
      );
      console.log(res);
      if (res !== 1) {
        return this.$message.error("删除失败！");
      }
      this.$message.success("删除成功！");
      this.getMateriaList();
      this.getMateriaList1();
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 调用接口新增物料
    addMateria() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        // 将汉字转为数字判断
        if (this.addForm.Workpiece_One == "无") {
          this.Workpiece_OneNum = "00";
        }
        if (this.addForm.Workpiece_One == "黑色") {
          this.Workpiece_OneNum = "01";
        }
        if (this.addForm.Workpiece_One == "红色") {
          this.Workpiece_OneNum = "02";
        }
        if (this.addForm.Workpiece_Two == "无") {
          this.Workpiece_TwoNum = "00";
        }
        if (this.addForm.Workpiece_Two == "黑色") {
          this.Workpiece_TwoNum = "01";
        }
        if (this.addForm.Workpiece_Two == "红色") {
          this.Workpiece_TwoNum = "02";
        }
        if (this.addForm.Workpiece_Three == "无") {
          this.Workpiece_ThreeNum = "00";
        }
        if (this.addForm.Workpiece_Three == "黑色") {
          this.Workpiece_ThreeNum = "01";
        }
        if (this.addForm.Workpiece_Three == "红色") {
          this.Workpiece_ThreeNum = "02";
        }
        this.choose();
        this.addForm.StorageLocationNOP = this.addForm.StorageLocationNO;
        let params = new URLSearchParams();
        this.addForm.WorkpieceInfo =
          this.addForm.SessionNumber +
          this.Workpiece_OneNum +
          this.Workpiece_TwoNum +
          this.Workpiece_ThreeNum +
          this.addForm.StorageLocationNOP +
          this.addForm.PartStatusNO;
        this.addForm.MaterialCode =
          this.addForm.SessionNumber +
          this.Workpiece_OneNum +
          this.Workpiece_TwoNum +
          this.Workpiece_ThreeNum +
          this.addForm.StorageLocationNOP +
          this.addForm.PartStatusNO;
        // console.log('555' + this.addForm.Workpiece_One.value)
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("MaterialName", this.addForm.MaterialName);
        params.append("MaterialCode", this.addForm.WorkpieceInfo);
        params.append("Is_Use", this.addForm.Is_Use);
        params.append("Remark", this.addForm.Remark);
        params.append("Spec", this.addForm.Spec);
        params.append("Unit", this.addForm.Unit);
        params.append("SessionNumber", this.addForm.SessionNumber);
        // params.append("Workpiece_One", this.addForm.Workpiece_One)
        // params.append("Workpiece_Two", this.addForm.Workpiece_Two)
        // params.append("Workpiece_Three", this.addForm.Workpiece_Three)
        // params.append("StorageLocationNO", this.addForm.StorageLocationNO)
        // params.append("PartStatus", this.addForm.PartStatus)
        params.append("WorkpieceInfo", this.addForm.WorkpieceInfo);
        params.append("ProductType_ID", this.addForm.TypeID);
        // console.log('10086' + params)
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "/WMS/InsertMaterialset",
          params
        );
        // console.log(res)
        // if (res == -3) {
        //     return this.$message.error('新增失败,库位已被占用！')
        // }
        if (res == -4) {
          return this.$message.error("新增失败,工件信息重复！");
        }
        if (res != 1) {
          return this.$message.error("新增失败！");
        }
        console.log(res.data);
        this.$message.success("添加物料成功！");
        // 隐藏添加用户的对话框
        this.addDialogVisible = false;
        // 重新获取用户列表数据
        this.getMateriaList();
        this.getMateriaList1();
      });
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    // 展示修改物料的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true;
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.get("/WMS/queryMaterialsetID", {
        params,
      });
      console.log(res.data);
      this.editForm = res.data[0];
    },
    // 调用接口编辑物料类型
    editMateria() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("MaterialName", this.editForm.MaterialName);
        params.append("MaterialCode", this.editForm.MaterialCode);
        params.append("ID", this.editForm.ID);
        params.append("CreateTime", this.editForm.CreateTime);
        params.append("Is_Use", this.editForm.Is_Use);
        params.append("Remark", this.editForm.Remark);
        params.append("Spec", this.editForm.Spec);
        params.append("Unit", this.editForm.Unit);
        const { data: res } = await this.$http.post(
          "/WMS/updateMaterialset",
          params
        );
        console.log(res);
        if (res !== 1) {
          this.$message.error("更新物料类型信息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getMateriaList();
        this.getMateriaList1();
        // 提示修改成功
        this.$message.success("更新物料类型信息成功！");
      });
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      console.log("111" + newSize);
      this.getTypeList.limit = newSize;
      this.getMateriaList();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      console.log(newPage);
      this.getTypeList.page = newPage;
      this.getMateriaList();
    },
    getpdfyes() {
      this.getPdf();
    },
    // 调用接口获取仓位信息
    async getStorageInSelect() {
      let params = new URLSearchParams();
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("page", this.getTypeList.privateKey);
      params.append("limit", this.getTypeList.appIdentification);
      const { data: res } = await this.$http.get("/WMS/InSelect", { params });
      console.log("dasdasd");
      console.log(res.data);
      this.productSetingList = res.data;
    },
    // 调用接口查询产品类型信息
    async getProductType() {
      const { data: res } = await this.$http.get("/WMS/queryProductType", {
        params: this.getTypeList,
      });
      console.log(res.data);
      for (var i = 0; i < res.data.length; i++) {
        if (res.data[i].Is_Use == "Y") {
          res.data[i].Is_Use = "是";
        }
        if (res.data[i].Is_Use == "N") {
          res.data[i].Is_Use = "否";
        }
      }
      this.productTypelist = res.data;
    },
    // 判断选择的产品类型，并给其他工件赋值
    choose() {
      if (this.addForm.TypeName == "01") {
        this.Workpiece_TwoNum = "00";
        this.addForm.Workpiece_Two = "无";
        this.Workpiece_ThreeNum = "00";
        this.addForm.Workpiece_Three = "无";
      }
      if (this.addForm.TypeName == "02") {
        this.Workpiece_OneNum = "00";
        this.addForm.Workpiece_One = "无";
        this.Workpiece_ThreeNum = "00";
        this.addForm.Workpiece_Three = "无";
      }
      {
        if (this.addForm.TypeName == "03") {
          this.Workpiece_OneNum = "00";
          this.addForm.Workpiece_One = "无";
          this.Workpiece_TwoNum = "00";
          this.addForm.Workpiece_Two = "无";
        }
      }
    },
    // 产品处理
    selectNum(event) {
      console.log(event);
      this.addForm.TypeName = event.code;
      this.addForm.TypeID = event.IDS;
    },
  },
};
</script>

<style lang="less" scoped>
</style>


